function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { getValidRgbaColor } from "../../helpers/rbg";
const checkerSize = 9.1;
const checkerColor = "#E3E3E3";
const swatchBg = {
    backgroundColor: "#BBBBBB",
    backgroundImage: `linear-gradient(45deg, ${checkerColor} 25%, transparent 25%), linear-gradient(-45deg, ${checkerColor} 25%, transparent 25%), linear-gradient(45deg, transparent 75%, ${checkerColor} 75%), linear-gradient(-45deg, transparent 75%, ${checkerColor} 75%)`,
    backgroundSize: `${checkerSize}px ${checkerSize}px`,
    backgroundPosition: `0 0, 0 ${checkerSize / 2}px, ${checkerSize / 2}px -${checkerSize / 2}px, -${checkerSize / 2}px 0px`
};
export const Swatch = ({ color, isDyanamic, onClick })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "!cursor-pointer w-[22px] h-[22px] relative rounded-[3px] overflow-hidden",
        style: _object_spread({}, swatchBg),
        onClick: onClick,
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-full h-full",
            style: {
                background: getValidRgbaColor(color) ? color : `rgba(0, 0, 0, 0)`
            }
        })
    });
};
